import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

import { useTrans } from '~/hooks/useTrans';
import { IService } from "~/providers/interfaces";
import Loader from '~/components/Loader';
import MyCheckbox from "~/mui/MyCheckbox";

interface IAdminServicesTable {
	loading: boolean;
	items: Array<IService>;
	onEdit: (service: IService) => void;
	onRemove: (service: IService) => void;
}

export default function AdminServicesTable({
	loading = true,
	items = [],
	onEdit = () => {},
	onRemove = () => {},
}: IAdminServicesTable) {
	const { trans } = useTrans();
	const HEADERS: Array<{
		trans: string;
		center?: boolean;
	}> = [
		{ trans: "adminServicesPage.table.id" },
		{ trans: "adminServicesPage.table.service" },
		{ trans: "adminServicesPage.table.callPrice", center: true },
		{ trans: "adminServicesPage.table.serviceType" },
		{ trans: "adminServicesPage.table.hiddenForUsers", center: true },
		{ trans: "adminServicesPage.table.regularService", center: true },
		{ trans: "adminServicesPage.table.rootServiceId" },
		{ trans: "" },
	];

	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADERS.map(header => <TableCell sx={{ fontWeight: "bold", ...header.center ? { textAlign: "center" } : {} }} key={header.trans}>
						{ header.trans && trans(header.trans) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ items.map(service => (<TableRow key={service.id}>
					<TableCell>{ service.id }</TableCell>
					<TableCell>{ service.service }</TableCell>
					<TableCell className="text-align-center">{ service.callPrice }</TableCell>
					<TableCell>{ service.serviceType.toLowerCase() }</TableCell>
					<TableCell className="text-align-center"><MyCheckbox checked={service.hiddenForUsers} label="" onChange={() => {}} sx={{ marginRight: "0" }} /></TableCell>
					<TableCell className="text-align-center"><MyCheckbox checked={service.regularService} label="" onChange={() => {}} sx={{ marginRight: "0" }} /></TableCell>
					<TableCell>{ service.rootServiceId || "" }</TableCell>
					<TableCell>
						<div style={{ display: "flex", gap: "var(--margin-small)", justifyContent: "center", alignItems: "center" }}>
							<Button color="success" onClick={() => onEdit(service)}>
								<EditIcon />
							</Button>
							<Button color="success" onClick={() => onRemove(service)}>
								<DeleteIcon />
							</Button>
						</div>
					</TableCell>
				</TableRow>)) }
				{ items.length === 0 && <TableRow>
					<TableCell colSpan={HEADERS.length} className="text-align-center">
						{ loading && <Loader msg={trans("loadingData")} /> }
						{ !loading && trans("emptyTable") }
					</TableCell>
				</TableRow> }
			</TableBody>
		</Table>
	</TableContainer>;
}
